'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _messages = require('common/messages');

var _ingredientRisk = require('./ingredient-risk.html');

var _ingredientRisk2 = _interopRequireDefault(_ingredientRisk);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _ingredientRisk2.default,
  bindings: {},
  controller: function () {
    function IngredientRiskComponent(LoadingService, IngredientRiskService, ToastService) {
      'ngInject';

      _classCallCheck(this, IngredientRiskComponent);

      Object.assign(this, {
        LoadingService: LoadingService,
        IngredientRiskService: IngredientRiskService,
        ToastService: ToastService
      });
    }

    _createClass(IngredientRiskComponent, [{
      key: 'downloadReport',
      value: function downloadReport() {
        var _this = this;

        if (this.selectedIngredient) {
          this.LoadingService.start();

          this.IngredientRiskService.getReport(this.selectedIngredient.SystemIngredientId).then(function () {
            return _this.ToastService.showSuccess(_messages.INGREDIENT_RISK_REPORT_GENERATED);
          }).catch(function (error) {
            return _this.ToastService.showError(error);
          }).finally(function () {
            return _this.LoadingService.stop();
          });
        }
      }
    }, {
      key: 'selectedIngredientChanged',
      value: function selectedIngredientChanged(_ref) {
        var selectedIngredient = _ref.selectedIngredient;

        this.selectedIngredient = selectedIngredient;
      }
    }]);

    return IngredientRiskComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/reports/ingredient-risk/ingredient-risk.component.js